export default __webpack_public_path__ + "static/media/seafood.bc41ce9d.webp";